<template>
  <DBox
    :id="'cmp-royalty-contracts-sidewindow-contract_setup'"
    :addButton="false"
  >
    <!-- :expandable="true" -->
    <TextField2
      :id="'contract_name'"
      :placeholder="$t('contract_name')"
      :label="$t('contract_name')"
      :value="selectedContractDetails.contract.contract_name"
      @blur="onTextFieldValueChange"
    />

    <!-- no-border -->
    <div class="fc2 setup-row ut-flex">
      <label class="label-title txtov">{{
        $dft.snakeCaseToWords("Use as Template")
      }}</label>

      <div class="ut-flex no-right-padding">
        <div style="padding-right: 10px" class="no-label">
          <div class="dt-checkbox v2 s1">
            <input
              type="checkbox"
              :name="'template_flag'"
              :id="'template_flag'"
              :checked="selectedContractDetails.contract.template_flag"
              @click="(e) => onCheckboxChange('template_flag', e)"
            />
            <div class="checkmark"></div>
          </div>
        </div>
        <TextField2
          v-if="selectedContractDetails.contract.template_flag"
          :bb="'0px'"
          style="width: 100%"
          :showLabel="false"
          :id="'template_name'"
          :placeholder="$t('template_name')"
          :label="$t('template_name')"
          :value="selectedContractDetails.contract.template_name"
          @blur="onTextFieldValueChange"
        />
      </div>
    </div>
    <!-- <div class="setup-row ut-flex">
      <label class="label-title txtov">{{
        $dft.snakeCaseToWords("Use as Template")
      }}</label>

      <div class="ut-flex flex-auto">
        <div class="dt-checkbox v2 s1">
          <input
            type="checkbox"
            :name="'template_flag'"
            :id="'template_flag'"
            :checked="selectedContractDetails.contract.template_flag"
            @click="(e) => onCheckboxChange('template_flag', e)"
          />
          <div class="checkmark"></div>
        </div>
      </div>
      <div class="flex-grow"></div>
      <img
        title=""
        src="static/icons/help.svg"
        alt=""
        class="dt-icon v5 s20 fc2-hint mr-1"
      />
      <TextField2
        :showLabel="false"
        :id="'contract_name'"
        :placeholder="$t('contract_name')"
        :label="$t('contract_name')"
        :value="selectedContractDetails.contract.contract_name"
        @blur="onTextFieldValueChange"
      />
    </div> -->

    <DatePicker2
      id="contract_start"
      :label="$t('start')"
      :value="selectedContractDetails.contract.contract_start"
      @input="onDateUpdate"
    />
    <DatePicker2
      id="contract_end"
      :label="$t('end')"
      :value="selectedContractDetails.contract.contract_end"
      @input="onDateUpdate"
    />

    <!-- no-border -->
    <div
      :style="{
        borderBottom:
          selectedContractDetails.contract.mechanical_flag == 1
            ? 'none'
            : '1px solid var(--sprt-85)',
      }"
      class="fc2 setup-row ut-flex"
    >
      <label class="label-title txtov">{{
        $dft.snakeCaseToWords("contract_status")
      }}</label>

      <div class="ut-flex no-right-padding">
        <div
          class="no-label"
          v-for="status in statuses"
          :key="status.label_status_id"
        >
          <span
            v-if="
              selectedContractDetails.contract.contract_label_status_id ===
              status.label_status_id
            "
            class="circle"
            :style="{
              backgroundColor: `#${status.label_status_colour}`,
            }"
          ></span>
        </div>
        <Dropdown2
          :disabled="selectedContractDetails.disabled"
          :showLabel="false"
          :placeholder="$t('contract_status')"
          :bb="'0px'"
          :options="selectedContractDetails.labelStatusesTV"
          :selected="
            selectedContractDetails.labelStatusesTV.find(
              (e) =>
                e.value ==
                selectedContractDetails.contract.contract_label_status_id
            )
          "
          v-on:selectedChange="(e) => onDropdownChange('label_status_id', e)"
        />
      </div>
    </div>

    <Dropdown2
      v-if="!selectedContractDetails.contract.mechanical_flag"
      :label="$t('recoupable_type')"
      :placeholder="$t('recoupable_type')"
      :options="selectedContractDetails.costSplitTypesTV"
      :selected="
        selectedContractDetails.costSplitTypesTV.find(
          (e) => e.value == selectedContractDetails.contract.cost_split_type
        )
      "
      v-on:selectedChange="(e) => onDropdownChange('cost_split_type', e)"
    />

    <div
      v-if="!selectedContractDetails.contract.mechanical_flag"
      class="ut-flex"
    >
      <TextField2
        :ta="'right'"
        :id="'cost_split_percent'"
        :type="'percent'"
        :placeholder="$t('share')"
        :label="$t('share')"
        :value="selectedContractDetails.contract.cost_split_percent"
        :bb="'none'"
        :cw="`clamp(30px, ${
          (
            (selectedContractDetails &&
              selectedContractDetails.contract &&
              selectedContractDetails.contract.cost_split_percent) + 8 || ''
          ).toString().length * 12
        }px, 250px)`"
        @blur="onTextFieldValueChange"
      />
    </div>

    <!-- <div class="fc2 setup-row ut-flex">
      <label class="label-title txtov">{{
        $dft.snakeCaseToWords("royalty_account")
      }}</label>
      <div class="ut-flex ut-link ut-text-accent5">
        <span
          @click="
            e =>
              onRoyaltyAccountSelected(
                selectedContractDetails.contract.royalty_account_id
              )
          "
          >{{
            selectedContractDetails.contract.royalty_account_name ||
              "Royalty Account"
          }}</span
        >
      </div>
    </div>

    <TextField2
      disabled="disabled"
      :id="'contract_id'"
      :placeholder="$t('contract_id')"
      :label="$t('contract_id')"
      :value="selectedContractDetails.contract.contract_id"
      @blur="onTextFieldValueChange"
    />
    
    <TextField2
      disabled="disabled"
      :id="'contract_type'"
      :placeholder="$t('contract_type')"
      :label="$t('contract_type')"
      :value="selectedContractDetails.contract.deal_type_name"
      @blur="onTextFieldValueChange"
    />
    <TextField2
      disabled="disabled"
      :id="'sage_id'"
      :placeholder="$t('royalty_account_id')"
      :label="$t('royalty_account_id')"
      :value="selectedContractDetails.contract.sage_id"
      @blur="onTextFieldValueChange"
    />
    <TextField2
      disabled="disabled"
      :id="'currency'"
      :placeholder="$t('currency')"
      :label="$t('currency')"
      :value="selectedContractDetails.contract.currency"
      @blur="onTextFieldValueChange"
    />
    <TextField2
      disabled="disabled"
      :id="'id_prod'"
      :placeholder="$t('id_prod')"
      :label="$t('id_prod')"
      :value="selectedContractDetails.contract.id_prod"
      @blur="onTextFieldValueChange"
    />
    <TextField2
      disabled="disabled"
      :id="'account_page'"
      :placeholder="$t('account_page')"
      :label="$t('account_page')"
      :value="selectedContractDetails.contract.deal_partner"
      @blur="onTextFieldValueChange"
    />
    <TextField2
      disabled="disabled"
      :id="'legal_entity'"
      :placeholder="$t('legal_entity')"
      :label="$t('legal_entity')"
      :value="selectedContractDetails.contract.company_name"
      @blur="onTextFieldValueChange"
    />
    <TextField2
      disabled="disabled"
      :id="'company_code'"
      :placeholder="$t('company_code')"
      :label="$t('company_code')"
      :value="selectedContractDetails.contract.company_code"
      @blur="onTextFieldValueChange"
    />
    <TextField2
      disabled="disabled"
      :id="'cost_center'"
      :placeholder="$t('cost_center')"
      :label="$t('cost_center')"
      :value="selectedContractDetails.contract.cost_center_code"
      @blur="onTextFieldValueChange"
    />
    <TextField2
      disabled="disabled"
      :id="'cost_center_description'"
      :placeholder="$t('cost_center_description')"
      :label="$t('cost_center_description')"
      :value="selectedContractDetails.contract.cost_center_name"
      @blur="onTextFieldValueChange"
    />
    <TextField2
      disabled="disabled"
      :id="'brand'"
      :placeholder="$t('brand')"
      :label="$t('brand')"
      :value="selectedContractDetails.contract.brand"
      @blur="onTextFieldValueChange"
    />
    <DatePicker2
      id="display_start"
      :label="$t('b2b_display_start')"
      :value="selectedContractDetails.contract.display_start"
      @input="onDateUpdate"
    />
    <Dropdown2
      :label="$t('catalog_auto_attachmen')"
      :placeholder="$t('catalog_auto_attachmen')"
      :options="autofetchProjectTV"
      :selected="
        autofetchProjectTV.find(
          e => e.value == selectedContractDetails.contract.autofetch_project
        )
      "
      v-on:selectedChange="e => onDropdownChange('autofetch_project', e)"
    /> -->
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";

export default {
  components: {
    DBox,
  },
  data: function () {
    return {
      disabled: false,
    };
  },
  props: ["selectedContractDetails"],
  computed: {
    autofetchProjectTV: function () {
      return [
        { text: "On", value: 1 },
        { text: "Off", value: 2 },
      ];
    },
    statuses: function () {
      return this.selectedContractDetails?.label_statuses || [];
    },
  },
  methods: {
    onTextFieldValueChange: function (event) {
      const { name, value } = event;
      this.$emit("changed", { name, value });
    },
    onDropdownChange: function (name, value) {
      this.$emit("changed", { name, value: value.value });
    },

    onDateUpdate: function ({ name, value }) {
      this.$emit("changed", { name, value });
    },
    onCheckboxChange: function (name, value) {
      value = value.target.checked ? "1" : "0";
      this[name] = value;
      this.$emit("changed", { name, value });
    },
  },
};
</script>

<style lang="scss">
.cmp-royalty-contracts-sidewindow-contract_setup {
  .dropdown-2,
  .fc2-textfield,
  .fc2-datepicker {
    --fc2-lw: 125px !important;
  }
  
  .setup-row {
    padding: 0 0 0 10px;
    --bb: 1px solid var(--sprt-85);
    height: 30px;
    min-height: 30px;
    border-bottom: var(--bb);

    &.no-border {
      border-bottom-color: transparent;
    }

    .label-title,
    .icon,
    .title {
      flex: 1;
    }
    .label-title,
    .title-txt {
      max-width: 115px;
      color: var(--text-5);
    }
    > .ut-flex {
      flex: 1;
      padding: var(--fc2-tf-padding);
      margin: var(--fc2-tf-margin);
      min-width: 0;
      outline: none;

      &.flex-auto,
      &.no-right-padding {
        padding-left: 21px;
      }

      &.flex-auto {
        flex: 0 1 auto;
      }

      &.no-right-padding {
        padding-right: 0;
      }

      span {
        display: block;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
    .icon {
      min-height: 22px;
      justify-content: flex-end;
    }

    .dropdown-2 {
      flex: 1;
    }

    .no-label {
      .label-title {
        display: none;
      }
    }
    .circle {
      margin-right: 10px;
    }
    .flex-grow {
      flex-grow: 1;
    }
  }
}
</style>
